import React, { useState } from 'react';

const ToggleCustomSubgroups = ({
  question, questions, setQuestions,
  customSubgroupsMode, setCustomSubgroupsMode
}) => {
  const [ id ] = useState(() => (`Custom Question-${Date.now()}`));

  const onManageUpdate = (event) => {
    const newValue = !customSubgroupsMode;
    setCustomSubgroupsMode(newValue);
    question.use_custom_subgroups = newValue;
    setQuestions([ ...questions ]);
  };

  return (
    <>
      {
        (
          <div className="toggle -manage -five-point-scale" >
            <div className="form_section-title -grid">
              <div className="form_section-title-item -grid">
                <input
                  className="hide"
                  type="checkbox"
                  checked={ customSubgroupsMode }
                  id={ id }
                  onChange={ () => {} }
                />
                <label className="form-switch" htmlFor={ id } onClick={ onManageUpdate } >
                  {`Toggle ${question.answers.length}-point scale question`}
                </label>
              </div>
            </div>
            <div className="form_section-title -grid">
              <div className="form_section-title-item -grid">
                <div className="form_section-text -bold">Custom Subgroups</div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default ToggleCustomSubgroups;
